import { createContext, useContext } from "react"

export interface DropTargetData {
  id: string
  // Read live from the DOM at hit-test time. The drop zone's position
  // can shift after registration (images loading, layout reflow), so a
  // captured-once DOMRect goes stale.
  getRect: () => DOMRect
  isDraggedOver: boolean
  onUserDragOver?: DragDropHandler
  onUserDragExit?: DragDropHandler
  onUserDrop?: DragDropHandler
}

export type DragDropHandler = (itemId: string) => void

export interface TargetHash {
  [id: string]: DropTargetData
}

export interface DragDropContextState {
  targets: TargetHash
  usedTouchIds: number[]
  
  addTouchId: (id: number) => void
  removeTouchId: (id: number) => void
  
  addTarget: (target: DropTargetData) => void
  removeTarget: (id: string) => void
  onDragOver(e: {itemId: string, targetId: string, onUserDragStart?: DragDropHandler}): void
  onDragExit(e: {itemId: string, targetId: string}): void
  onDrop(e: {itemId: string, targetId: string}): void
}

export const DragDropContext = createContext<DragDropContextState>(undefined as any)

export function useDragDrop() {
  return useContext(DragDropContext);
}